export default __webpack_public_path__ + "95665c1ec014ae92a2f7624bb8d2401b.svg";